/* eslint-disable */

const toast = () => {
  const toastClosers = document.querySelectorAll('.js-toast-remove');

  toastClosers.forEach(closer => {
    closer.addEventListener('click', e => {
      e.target.closest('.js-toast').remove();
    });
  });
};

export default toast;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/toast.js